import React, { Component } from 'react';
import axios from 'axios'
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'
import { Multiselect } from 'multiselect-react-dropdown';
import Server from './../Server.js'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { confirmAlert } from 'react-confirm-alert';
import { OrderList } from 'primereact/orderlist';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Toast } from "primereact/toast";

class Create_Poll extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.FieldRef = React.createRef();

    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.setPolls = this.setPolls.bind(this);
    this.state = {
      layout: 'list',
      name: "",
      FId: "",
      DbTableName: "",
      DBTableField: ""

    }


  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0
      })

      that.GetPolls();

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }
  
  setPolls() {
    let that = this;
    let Filters = []
    
    this.state.FilterListForDropDown.map((v,index)=>{
      if(v.checked){
        Filters.push({
          id:v.id,
          name:v.name
        })
      }
        
    })

    let param = {
      token: localStorage.getItem("api_token"),
      _id: this.state.selectedId,
      name: this.state.name,
      number: parseInt(this.state.number),
      questions : Filters,
      Active:this.state.Active,
      desc:this.state.desc,
      icon:this.state.icon,
      latinName:this.state.latinName
    };
    this.setState({
      loading: 1
    })
    this.setState({
      HasErrorForMaps: null
    })
    let SCallBack = function (response) {
      that.onHideFormsDialog();
      that.GetPolls();
      that.setState({
        loading: 0
      })
     that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
      that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
    }
    this.Server.send("AdminApi/setPolls", param, SCallBack, ECallBack)
  }
  CreateForm() {
    this.setState({
      visibleManageField: true,
      name: "",
      number: "",
      selectedId: null,
      Active:false,
      icon:"",
      latinName:"",
      desc:""
    })

  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null
    });

  }
  onHideMapsDialog(event) {
    this.setState({
      visibleManageMaps: false,
      HasErrorForMaps: null
    });

  }
  selectedComponentChange(value) {
    let that = this;
    var FilterSelectedIds = [];
    value.questions.map((v,index)=>{
      FilterSelectedIds.push(v.id)
    })
    let FilterListForDropDown = this.state.FilterListForDropDown;
    FilterListForDropDown.map((v,index)=>{
      if(FilterSelectedIds.indexOf(v.id) > -1)
        v.checked = true;
      else
        v.checked = false;  
    })

    for(let i=0;i<FilterSelectedIds.length;i++){
      for(let j=0;j<FilterListForDropDown.length;j++){
        if(FilterListForDropDown[j].id == FilterSelectedIds[i])
          FilterListForDropDown[j].order=i;
      }
    }
    FilterListForDropDown.sort((a,b) => ((a.order||-1) > (b.order||-1)) ? 1 : (((b.order||-1) > (a.order||-1)) ? -1 : 0))

    var p = [];
    this.setState({
      name: value.name,
      number: value.number,
      selectedId: value._id,
      FieldSelected:value.Fields,
      visibleManageField: true,
      FilterListForDropDown:FilterListForDropDown,
      FilterSelected:value.Fields,
      Active:value.Active,
      icon:value.icon,
      desc:value.desc,
      latinName:value.latinName
    })

  }
  GetPolls() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      that.GetFields();
      that.setState({
        GridDataFields: response.data.result
      })
      that.setState({
        loading: 0
      })
    };
    let ECallBack = function (error) {
      that.GetFields();
      that.setState({
        loading: 0
      })
    }
    this.Server.send("AdminApi/getPolls", param, SCallBack, ECallBack)
  }
  delField(rowData) {

    this.setState({
      visibleManageField:false
    })
    confirmAlert({
      title: <span className="yekan">حذف کاربر</span>,
      message: <span className="yekan">  آیا از حذف  {rowData.name} مطمئنید  </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id,
              del:1
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0
              })
              that.GetPolls();
             that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0
              })
              that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
            }
            this.Server.send("AdminApi/setPolls", param, SCallBack, ECallBack)

          }
        },
        {
          label: <span className="yekan">خیر </span>
        }
      ]
    });

  }
  GetFields() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token")
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      that.setState({
        FieldList: response.data.result
      })
      
      let FieldList = [];
      for (let i = 0; i < response.data.result.length; i++) {
        FieldList.push({ name: response.data.result[i].text, id: response.data.result[i]._id,checked:false })
      }
      
      that.setState({
        FilterListForDropDown: FieldList,
        OrgFilterListForDropDown: FieldList,
        FieldListForDropDown: FieldList,
        loading: 0
      })

    };
    let ECallBack = function (error) {
      that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
      that.setState({
        loading: 0
      })
    }
    this.Server.send("AdminApi/getQuestions", {}, SCallBack, ECallBack)



  }
  
  render() {
    const footer = (
      <div>
        <button className="btn btn-primary irsans" onClick={this.setPolls} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}> اعمال </button>

      </div>
    );

    const delTemplate = (rowData, props) => {
      return <i className="fa fa-times" style={{ cursor: 'pointer' }} aria-hidden="true" onClick={() => this.delField(rowData)}></i>;
    }

    const itemTemplate = (item) => {
      let id = "cb" + item.id;
      return (
        <div className="product-item">

          <div className="product-list-detail" style={{ display: 'flex' }}>
            <Checkbox inputId={id} value={item.id} style={{ verticalAlign: 'text-bottom' }} onChange={(event)=>{
              let FilterListForDropDown = this.state.FilterListForDropDown;
              for(let i=0;i<FilterListForDropDown.length;i++){
                if(event.value ==  FilterListForDropDown[i].id)
                  FilterListForDropDown[i].checked = event.checked
              }
              this.setState({
                FilterListForDropDown:FilterListForDropDown
              })
            
            }} checked={this.state.FilterListForDropDown.filter(function (v) { return v.id == item.id })[0]?.checked == false ? false : true}></Checkbox>

            <h5 className="p-mb-2">{item.name}</h5>
          </div>

        </div>
      );
    }
    return (

      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }
        <div className="row justify-content-center">

          <div className="col-12" style={{ background: '#fff' }}>
            <div className="row" >
              <div className="col-6" style={{ textAlign: 'center' }}>
                <button className="btn btn-primary irsans" onClick={this.CreateForm} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}>ساخت نظرسنجی جدید</button>
              </div>

            </div>
            <div className="section-title " style={{ textAlign: 'right' }}><span className="title IRANYekan" style={{ fontSize: 17, color: 'gray' }} >لیست نظرسنجی ها</span></div>

            <DataTable responsive value={this.state.GridDataFields} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => this.selectedComponentChange(e.value)}>
              <Column field="number" header="شماره نظرسنجی" className="irsans" style={{ textAlign: "right" }} />
              <Column field="name" header="نام" className="irsans" style={{ textAlign: "right" }} />
              <Column field="latinName" header="نام لاتین" className="irsans" style={{ textAlign: "right" }} />
              <Column field="del" body={delTemplate} header="حذف" className="irsans" style={{ textAlign: "right" }} />
            </DataTable>
          </div>

        </div>


        <Dialog header={this.state.selectedId ? "اصلاح" : "ساخت نظرسنجی جدید"} visible={this.state.visibleManageField} footer={footer} onHide={this.onHideFormsDialog} maximizable={false} maximized={true}>
          <form>

            <div className="row">
              <div className="col-lg-6">
                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.number} name="number" onChange={(event) => this.setState({ number: event.target.value })} required="true" />
                  <label>شماره نظرسنجی</label>
                </div>
              </div>
              
              <div className="col-lg-12">

                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.name} name="name" onChange={(event) => this.setState({ name: event.target.value })} required="true" />
                  <label >عنوان</label>

                </div>
              </div>
              <div className="col-lg-12">

                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.latinName} name="latinName" onChange={(event) => this.setState({ latinName: event.target.value })} required="true" />
                  <label >عنوان لاتین</label>

                </div>
              </div>
              
              <div className="col-lg-12">

                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.icon} name="icon" onChange={(event) => this.setState({ icon: event.target.value })} required="true" />
                  <label >آیکن</label>

                </div>
              </div>
              <div className="col-lg-12">

                <div className="group">
                  <textarea className="form-control irsans" autoComplete="off" type="text" value={this.state.desc} name="desc" onChange={(event) => this.setState({ desc: event.target.value })} required="true" ></textarea>
                  <label >توضیح بالای نظرسنجی</label>

                </div>
              </div>
              
              <div className="col-lg-6">
                <div className="group"  style={{display:"none"}}>
                <Multiselect
                      placeholder="سوالات"
                      ref={this.FieldRef}
                      options={this.state.FieldListForDropDown} // Options to display in the dropdown
                      selectedValues={this.state.FieldSelected} // Preselected value to persist in dropdown
                      displayValue="name" // Property name to display in the dropdown options
                    />

                 </div>
                 <OrderList value={this.state.FilterListForDropDown} itemTemplate={itemTemplate} header="اختصاص سوال" onChange={(e) => {this.setState({ FilterListForDropDown: e.value })}}></OrderList>

              </div>
              <div className="col-lg-12">
                <div className="col-12" style={{ textAlign: 'right', display: 'flex', alignItems: 'baseline',padding:0 }}>
                      <Checkbox inputId="ShowPriceAftLogin" value={this.state.Active} checked={this.state.Active} onChange={e => this.setState({ Active: e.checked })}></Checkbox>
                      <label htmlFor="ShowPriceAftLogin" className="p-checkbox-label yekan" style={{ paddingRight: 5 }}> فعال</label>
                </div>
              </div>
              



            </div>
          </form>
        </Dialog>

      </div>





    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default connect(mapStateToProps)(Create_Poll);
